import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appGstInputValue]',
  standalone: false
})
export class GstInputValueDirective {

  private numberPattern = /[^0-9.]/g; 

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const input = this._el.nativeElement as HTMLInputElement;

    let cleanedValue = input.value.replace(this.numberPattern, '');

    const parts = cleanedValue.split('.');
    if (parts.length > 2) {
      cleanedValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // ✅ Limit to 2 digits after decimal
    if (parts[1]?.length > 2) {
      cleanedValue = parts[0] + '.' + parts[1].slice(0, 2);
    }

    if (input.value !== cleanedValue) {
      input.value = cleanedValue;
      event.stopImmediatePropagation();
    }
  }

}
